const commonAction = [{
    aKey  : 'LIST',
    aDesc : 'Listing'
  },
  {
    aKey  : 'ADD',
    aDesc : 'Add New'
  },
  {
    aKey  : 'VIEW',
    aDesc : 'View'
  },
  {
    aKey  : 'DELETE',
    aDesc : 'Delete'
  },
  {
    aKey  : 'EDIT',
    aDesc : 'Edit'
  }];

function mergeActions(tag, newArr) {
  return [...commonAction, ...newArr];
}

const siteActionList = [
  'DASHBOARD'
]
export default [
  {
    aLabel: 'Merchant',
    aList: [{
      aKey  : 'LIST_MERCHANT',
      aDesc : 'Listing Of Merchant',
      aUrl  : 'merchantList'
    },
    {
      aKey  : 'ADD_MERCHANT',
      aDesc : 'Add New Merchant',
      aUrl  : 'addMerchant'
    },
    {
      aKey  : 'VIEW_MERCHANT',
      aDesc : 'View Merchant',
      aUrl  : 'merchantDetails'
    },
    {
      aKey  : 'DELETE_MERCHANT',
      aDesc : 'Delete Merchant',
      aUrl  : 'deleteMerchant'
    },
    {
      aKey  : 'EDIT_MERCHANT',
      aDesc : 'Edit Merchant',
      aUrl  : 'addMerchant/edit'
    },
    {
      aKey  : 'W9INFO',
      aDesc : 'Manage W9 Info',
      aUrl  : 'merchant/w9info'
    }]
  },
  {
    aLabel: 'Contracts',
    aList: [{
      aKey  : 'LIST_CONTRACT',
      aDesc : 'Listing Of Contracts',
      aUrl  : 'contractList'
    },
    {
      aKey  : 'ADD_CONTRACT',
      aDesc : 'Add New Contract',
      aUrl  : 'addContract'
    },
    {
      aKey  : 'VIEW_CONTRACT',
      aDesc : 'View Contract',
      aUrl  : 'contractDetails'
    },
    {
      aKey  : 'DELETE_CONTRACT',
      aDesc : 'Delete Contract',
      aUrl  : 'deleteContract'
    },
    {
      aKey  : 'EDIT_CONTRACT',
      aDesc : 'Edit Contract',
      aUrl  : 'addContract/edit'
    },
    {
      aKey  : 'EXECUTE_CONTRACT',
      aDesc : 'Execute Contract',
      aUrl  : ''
    },
    {
      aKey  : 'VIEW_OFFERS',
      aDesc : 'View Offers',
      aUrl  : 'dealList'
    },
    {
      aKey  : 'EDIT_OFFER',
      aDesc : 'Edit Offer',
      aUrl  : 'editDeal'
    }]
  },
  {
    aLabel: 'Promo Codes',
    aList: [{
      aKey  : 'LIST_PROMO_CODE',
      aDesc : 'Listing of Promo Codes',
      aUrl  : 'promoList'
    },
    {
      aKey  : 'ADD_PROMO_CODE',
      aDesc : 'Add New Promo Code',
      aUrl  : 'addPromo'
    },
    {
      aKey  : 'DELETE_PROMO_CODE',
      aDesc : 'Delete Promo Code',
      aUrl  : 'deletePromoCode'
    },
    {
      aKey  : 'EDIT_PROMO_CODE',
      aDesc : 'Edit Promo Code',
      aUrl  : 'addPromo/edit'
    }]
  },
  {
    aLabel: 'Affiliate',
    aList: [{
      aKey  : 'LIST_AFFILIATE',
      aDesc : 'Listing Of Affiliates',
      aUrl  : 'affiliateList'
    },
    {
      aKey  : 'ADD_AFFILIATE',
      aDesc : 'Add New Affiliate',
      aUrl  : 'addAffiliate'
    },
    {
      aKey  : 'VIEW_AFFILIATE',
      aDesc : 'View Affiliate',
      aUrl  : 'affiliate/dashboard'
    },
    {
      aKey  : 'DELETE_AFFILIATE',
      aDesc : 'Delete Affiliate',
      aUrl  : 'deleteAffiliate'
    },
    {
      aKey  : 'EDIT_AFFILIATE',
      aDesc : 'Edit Affiliate',
      aUrl  : 'addAffiliate/edit'
    }]
  },
  {
    aLabel: 'Campaign Manager',
    aList: [{
        aKey  : 'LIST_COMPAIGN',
        aDesc : 'Listing Of Campaign',
        aUrl  : 'email-manager/overview'
      },
      {
        aKey  : 'ADD_COMPAIGN',
        aDesc : 'Add New Campaign',
        aUrl  : 'email-manager'
      },
      {
        aKey  : 'DELETE_COMPAIGN',
        aDesc : 'Delete Campaign',
        aUrl  : 'deleteCampaign'
      }]
  },
  {
    aLabel: 'Vouchers',
    aList: [{
      aKey  : 'LIST_VOUCHERS',
      aDesc : 'Listing Of Vouchers',
      aUrl  : 'voucherList'
    },
    {
      aKey  : 'GENERATE_VOUCHER',
      aDesc : 'Generate Voucher',
      aUrl  : 'generateVoucher'
    }]
  },
  {
    aLabel: 'Reports',
    aList: [{
      aKey  : 'TRANSACTION_REPORT',
      aDesc : 'Transactions Reports',
      aUrl  : 'report/transaction'  
    },
    {
      aKey  : 'SALES_REPORT',
      aDesc : 'Sales Reports',
      aUrl  : 'report/sales'
    },
    {
      aKey  : 'REFUNDS_REPORT',
      aDesc : 'Refunds Reports',
      aUrl  : 'report/refund'
    },

     {
      aKey  : 'REFUNDS_ARCHIVE_REPORT',
      aDesc : 'Refunds Archive Reports',
      aUrl  : 'report/archiverefund'
    },

    {
      aKey  : 'MERCHANT_PAYOUTS',
      aDesc : 'Merchant Payouts',
      aUrl  : 'report/merchant-payout'
    }]
  },
  {
    aLabel: 'Recurring',
    aList: [{
      aKey  : 'TRANSACTION_REPORT',
      aDesc : 'Customer Recurring Reports',
      aUrl  : 'report/CustomerRecurring'  
    },
    {
      aKey  : 'SALES_REPORT',
      aDesc : 'Recurring Payment Reports',
      aUrl  : 'report/RecurringPayment'
    },
    {
      aKey  : 'REFUNDS_REPORT',
      aDesc : 'Failed Recurring Reports',
      aUrl  : 'report/FailedRecurring'
    }]
  },
  {
    aLabel: 'Feedback',
    aList: [{
      aKey  : 'MANAGE_QUESTIONS',
      aDesc : 'Manage Questions',
      aUrl  : 'questions'
    },
    {
      aKey  : 'MANAGE_REVIEWS',
      aDesc : 'Manage Reviews',
      aUrl  : 'offerReviews'
    }]
  },
  {
    aLabel: 'Site Settings',
    aList: [{
      aKey  : 'EDIT_SITE',
      aDesc : 'Manage Site Detail',
      aUrl  : 'editSite'
    },
    {
      aKey  : 'EMAIL_SETTING',
      aDesc : 'Email Settings',
      aUrl  : 'emailSetting'
    },
    {
      aKey  : 'PAYMENT_SETTING',
      aDesc : 'Payments Settings',
      aUrl  : 'payment-setting'
    },
    {
      aKey  : 'CITY_LISTING',
      aDesc : 'City Listing',
      aUrl  : 'cityStatus'
    },
    {
      aKey  : 'PAGE_TEMPLATE',
      aDesc : 'Manage Static Pages',
      aUrl  : 'manageTermsPolicies'
    },
    {
      aKey  : 'EMAIL_TEMPLATE',
      aDesc : 'Manage Email Template',
      aUrl  : 'emailTemplate'
    },
    {
      aKey  : 'EDIT_EMAIL_TEMPLATE',
      aDesc : 'Edit Email Template',
      aUrl  : 'updateEmailTemplate'
    }]
  },
  {
    aLabel: 'Category',
    aList: [{
      aKey  : 'LIST_CATEGORY',
      aDesc : 'Listing Of Category',
      aUrl  : 'categories'
    },
    {
      aKey  : 'ADD_CATEGORY',
      aDesc : 'Add New Category',
      aUrl  : 'categories/addCategory'
    },
    {
      aKey  : 'VIEW_CATEGORY',
      aDesc : 'View Category',
      aUrl  : 'viewcategories'
    },
    {
      aKey  : 'DELETE_CATEGORY',
      aDesc : 'Delete Category',
      aUrl  : 'deleteCategory'
    },
    {
      aKey  : 'EDIT_CATEGORY',
      aDesc : 'Edit Category',
      aUrl  : 'addCategory/edit'
    }]
  },
  {
    aLabel: 'Manage Employee',
    aList: [{
      aKey  : 'LIST_EMPLOYEE',
      aDesc : 'Listing Of Employee',
      aUrl  : 'userList'
    },
    {
      aKey  : 'ADD_EMPLOYEE',
      aDesc : 'Add New Employee',
      aUrl  : 'addSubAdmin'
    },
    {
      aKey  : 'VIEW_EMPLOYEE',
      aDesc : 'View Employee',
      aUrl  : 'userDetails'
    },
    {
      aKey  : 'DELETE_EMPLOYEE',
      aDesc : 'Delete Employee',
      aUrl  : 'deleteEmployee'
    },
    {
      aKey  : 'EDIT_EMPLOYEE',
      aDesc : 'Edit Employee',
      aUrl  : 'addSubAdmin/edit'
    },
    {
      aKey  : 'MANAGE_ACL',
      aDesc : 'Manage ACL Permissions',
      aUrl  : 'acl/settings'
    }]
  },
  {
    aLabel: 'Assets Manager',
    aList: [{
      aKey  : 'LIST_ASSET',
      aDesc : 'Listing Of Assets',
      aUrl  : 'assets/list'
    },
    {
      aKey  : 'ADD_ASSET',
      aDesc : 'Add New Asset',
      aUrl  : 'assets/add'
    },
    {
      aKey  : 'DELETE_ASSET',
      aDesc : 'Delete Asset',
      aUrl  : 'deleteAsset'
    },
    {
      aKey  : 'EDIT_ASSET',
      aDesc : 'Edit Asset',
      aUrl  : 'asset/edit'
    }]
  },
  {
    aLabel: 'Asset Color Manager',
    aList: [{
      aKey  : 'LIST_ASSET_COLOR',
      aDesc : 'Listing Of Asset Color',
      aUrl  : 'assets/color/list'
    },
    {
      aKey  : 'ADD_ASSET_COLOR',
      aDesc : 'Add New Asset Color',
      aUrl  : 'asset/color/add'
    },
    {
      aKey  : 'DELETE_ASSET_COLOR',
      aDesc : 'Delete Asset Color',
      aUrl  : 'deleteAssetColor'
    },
    {
      aKey  : 'EDIT_ASSET_COLOR',
      aDesc : 'Edit Asset Color',
      aUrl  : 'asset/color/edit'
    }]
  },
  {
    aLabel: 'FAQ',
    aList: [{
      aKey  : 'LIST_FAQ',
      aDesc : 'Listing Of FAQ',
      aUrl  : 'faqList'
    },
    {
      aKey  : 'ADD_FAQ',
      aDesc : 'Add New FAQ',
      aUrl  : 'addFaq'
    },
    {
      aKey  : 'DELETE_FAQ',
      aDesc : 'Delete FAQ',
      aUrl  : 'deleteFAQ'
    },
    {
      aKey  : 'EDIT_FAQ',
      aDesc : 'Edit FAQ',
      aUrl  : 'editFaq'
    }]
  }
];


// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/aclList.js